export const TOGGLE_FILTERS_PANEL = 'TOGGLE_FILTERS_PANEL';
export const TOGGLE_SUBSCRIBE_POPUP = 'TOGGLE_SUBSCRIBE_POPUP';
export const SET_IS_HOTEL_ONLY = 'SET_IS_HOTEL_ONLY';
